import { useState } from "react";
import { Card, CardBody, Col, Row, TabContent, TabPane } from "reactstrap";
import { OrgenizationTitle } from "../../../../../Constants/Constants";
import { OrganizationList } from "../../../../../Data/Applications/Contacts/Contacts";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import NavOrganization from "./NavOrganization";
import OrganizationTabPane from "./OrganizationTabPane";

const OrganizationTab = () => {
  const [orgActiveTab, setOrgActiveTab] = useState(1);

  return (
    <Card className="mb-0">
      <CommonCardHeader headClass="d-flex" title={OrgenizationTitle} span={[{ text: "5 Contacts" }]} />
      <CardBody className="p-0">
        <Row className="list-persons">
          <NavOrganization orgActiveTab={orgActiveTab} setOrgActiveTab={setOrgActiveTab} />
          <Col xl="8" md="7" className="xl-50">
            <TabContent activeTab={orgActiveTab}>
              {OrganizationList.map((user) => (
                <TabPane tabId={user.id} key={user.id}>
                  <OrganizationTabPane user={user} />
                </TabPane>
              ))}
            </TabContent>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
export default OrganizationTab;
